import PassportPortraitPhoto from "./PassportPortraitPhoto.component";

export default PassportPortraitPhoto;
